import { render, staticRenderFns } from "./sureOrdernewfl.vue?vue&type=template&id=1596e6a2&scoped=true&"
import script from "./sureOrdernewfl.vue?vue&type=script&lang=js&"
export * from "./sureOrdernewfl.vue?vue&type=script&lang=js&"
import style0 from "./sureOrdernewfl.vue?vue&type=style&index=0&id=1596e6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596e6a2",
  null
  
)

export default component.exports